import React, { FC } from 'react';

import Actions, { MenuType } from '~/components/Actions';

interface ModalFooterProps {
  buttons?: MenuType;
}

const ModalFooter: FC<ModalFooterProps> = ({ buttons }) => {
  if (!buttons || (0 === buttons.left?.length && 0 === buttons.right?.length)) {
    return null;
  }

  return (
    <div className="flex items-center justify-between space-x-3 border-t p-[20px]">
      <div>{buttons.left && <Actions items={buttons.left} />}</div>
      <div>{buttons.right && <Actions items={buttons.right} />}</div>
    </div>
  );
};

export default ModalFooter;
